const payload = data => {
  return {
    head: {
      clientId: "",
      version: "",
      timestamp: new Date().getTime(),
      channelId: "WEB",
      tokenType: "",
      signature: ""
    },
    body: data
  };
};
export const post = (url, data) => {
  data = payload(data);
  return fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    credentials: "same-origin",
    body: JSON.stringify(data)
  })
    .then(response => {
      return response.json();
    })
    .then(res => {
      if (res && res.body) {
        return new Promise((resolve, reject) => {
          if (res.body.resultInfo.resultStatus === "SUCCESS" || res.body.resultInfo.status === "SUCCESS") {
            resolve(res);
          } else {
            reject(res);
          }
        });
      }
      return Promise.reject(res);
    })
    .catch(error => {
      return Promise.reject(error);
    });
};

export const customPost = (url, data) => {
  return fetch(url, {
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    credentials: "same-origin",
    body: JSON.stringify(data)
  })
    .then(response => {
      return response.json();
    })
    .then(res => {
      if (res.status) {
        return new Promise((resolve, reject) => {
          if (res.status === "SUCCESS") {
            resolve(res);
          } else {
            reject(res);
          }
        });
      }
      return Promise.reject(res);
    })
    .catch(error => {
      return Promise.reject(error);
    });
};



// WEBPACK FOOTER //
// ./utils/http.js